export default __webpack_public_path__ + "static/media/virtualpad_bt_select.60bfd180.png";